"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const error_style_1 = __importDefault(require("./error.style"));
const typography_1 = require("components/atoms/typography");
const under_development_image_png_1 = __importDefault(require("assets/img/under-development-image.png"));
const Error404 = ({ theme = 'light' }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: error_style_1.default.notfoundContainer }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: error_style_1.default.notFoundSubContainer }, { children: [(0, jsx_runtime_1.jsx)("img", { alt: '', src: under_development_image_png_1.default, style: error_style_1.default.notFoundImage }), (0, jsx_runtime_1.jsx)(typography_1.Typography, Object.assign({ typographyType: 'h3', style: { color: theme === 'dark' ? 'white' : '#000' } }, { children: 'Under Development' }))] })) })));
};
exports.default = Error404;
